export const Bikes = [
    {
        id:1,
        image:"hum_berry_blue.jpeg",
        Brand : "Motovolt HUM MR",
        Price: "34499",
        Features: "Trellis Design",
        Suitablility:"City Commute, Long Distance Commute, Delivery Person"
    },
    {
        id:2,
        image:"Legend07.png",
        Brand : "EMotorad Legend07",
        Price: 32999,
        Features: "MSD Signature Edition",
        Suitablility:"Dhoni wali cycle"
    },
    {
        id:3,
        image:"Trexair.png",
        Brand : "EMotorad Trex Air",
        Price: "34799",
        Features: "Geared Beast for riders",
        Suitablility:"Perfect for riders and commuters"
    },
    {
        id:4,
        image:"STX.png",
        Brand : "EMotorad ST-X",
        Price: 35999,
        Features: "Ladybird of Electric Bicycles",
        Suitablility:"Perfect for girls/ladies"
    },
    {
        id:5,
        image:"TREXPRO.png",
        Brand : "EMotorad TREX Pro",
        Price: "52499",
        Features: "India's First In-Frame Light Horn Display 7 Gear Electric Bicycle",
        Suitablility:"Perfect blend of innovation and performance"
    },
    {
        id:6,
        image:"URBN_Orange_Front_View.jpeg",
        Brand : "Motovolt URBN",
        Price: "44499",
        Features: "Moped Style Cycle",
        Suitablility:"Perfect for Everyday Need"
    },
    {
        id:7,
        image:"R30 Facelift.jpg",
        Brand : "Rango R30",
        Price: 24499,
        Features: "Rango R30 Electric Bicycle with 7.8Ah Li-Ion Battery and color LCD display having error detection codes",
        Suitablility:"Perfect for Schoolers and Daily Commute"
    },

    {
        id:8,
        image:"X1.png",
        Brand : "EMotorad X1",
        Price: 27999,
        Features: "X1 is built for daily coffee runs, off-road endeavours, and everything in between",
        Suitablility:"Budget electric bicycle with best performance"
    },

    {
        id:9,
        image:"X2.png",
        Brand : "EMotorad X2",
        Price: 31999,
        Features: "Impressive 40+ km range, speed upto 25 km/h, High Tensile Step-Through Steel Frame",
        Suitablility:"Perfect for Everyday need"
    },

    {
        id:10,
        image:"X3.png",
        Brand : "EMotorad X3",
        Price: 34999,
        Features: "Hybrid E-Cycle with Frame Integrated Battery and 700C tyre",
        Suitablility:"Perfect for city ride"
    },

    {
        id:11,
        image:"TREXPLUS_V3.png",
        Brand : "EMotorad T-REX+ V3",
        Price: 44499,
        Features: "Impressive 45+ km range, speed upto 25 km/h , powerful motor, dual disc stopping, gives seamless riding with integrated display",
        Suitablility:"Perfect for Everyday need"
    },

    {
        id:12,
        image:"DOODLE_V3.png",
        Brand : "EMotorad Doodle",
        Price: 52499,
        Features: "Impressive 35+ km range, speed upto 25 km/h , folding MBT frame to aquire less space, gives powerful performance and smooth ride",
        Suitablility:"Perfect for Everyday need"
    },

    {
        id:13,
        image:"EMXPLUS.png",
        Brand : "EMotorad EMX+",
        Price: 52999,
        Features: "Impressive 50+ km range, speed upto 25 km/h, light powerful motor gives smooth experience",
        Suitablility:"Perfect for Everyday need"
    },

    {
        id:14,
        image:"cycle_gosporty.jpg",
        Brand : "Gosporty Bronze",
        Price: 24499,
        Features: "Impressive 30 km range, Detachable Carrier, Pedal Sensor, LED Display and IP65 Controller",
        Suitablility:"Perfect for long commuters"
    },

    {
        id:15,
        image:"LILE.png",
        Brand : "EMotorad LIL E",
        Price: 24499,
        Features: "Designed for teens, it delivers a smooth, exciting ride every time. Light and easy to handle, Lil E is always up for action and never runs out of fun",
        Suitablility:"Perfect for gated community and closed office premises"
    }

]